/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';
import { getEventId } from '@e180/domain/lib/event/util';

import LoginLinkSuccessDumb from './LoginLinkSuccessDumb';
import {
  resendLoginLinkWithMembershipId,
  resendLoginLinkWithUsername,
} from 'src/shared/app/authentication/action/support/supportLoginLinkActions';
import {
  getRetrievedMembership,
  getRetrievedUsername,
} from 'src/shared/app/authentication/selector/support/appRetrieveUsernameSelector';
import {
  getLoginLinkUsername,
  isLoginLinkResent,
} from 'src/shared/app/authentication/selector/support/appLoginLinkSelector';
import { getEventPublicData } from 'src/shared/domain/event/selector/eventSelectors';

const mapStateToProps = (state: Object): Object => {
  const event = getEventPublicData(state);

  return {
    username: getLoginLinkUsername(state) || getRetrievedUsername(state),
    isLinkResent: isLoginLinkResent(state),
    // Merge
    event,
    membership: getRetrievedMembership(state),
  };
};

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (stateProps: Object, { dispatch }: Object): Object => {
  let isResendBtnFrozen = false;

  return {
    ...stateProps,
    handleResendLink() {
      if (!isResendBtnFrozen) {
        isResendBtnFrozen = true;

        const { username, event, membership } = stateProps;
        const eventId = getEventId(event);

        return dispatch(
          membership
            ? resendLoginLinkWithMembershipId(membership, eventId)
            : resendLoginLinkWithUsername(username, eventId),
        ).then(() => {
          setTimeout(() => {
            isResendBtnFrozen = false;
          }, 10000);
        });
      }
    },
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(LoginLinkSuccessDumb);
